import { z } from "zod";

const LoginuserSchema = z.object({
  email: z
    .string()
    .nonempty("Email is required")
    .email("Please enter a valid email in the format 'example@domain.com'."),

  password: z.string().nonempty("Password is required"),
});

export default LoginuserSchema;
